import { useNavigation } from '@atom/hooks/useNavigation';
import { Icon, IconButton } from '@atom/mui';
import { ArrowBackIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';

import CreateFormModal from './CreateFormModal';

import classes from '../../styles/detail-header.module.css';

const RepositoryHeader = () => {
  const [, { navigate }] = useNavigation();

  const navigateToWorkOrders = () => {
    navigate('/workOrders');
  };
  return (
    <div className={classes.headerContainer}>
      <div className={classes.nameContainer}>
        <IconButton onClick={navigateToWorkOrders} tooltip="Go back">
          <Icon color={colors.neutral.white} icon={ArrowBackIcon} />
        </IconButton>
        <span>Work Forms</span>
      </div>
      <div className={classes.actionIconContainer}>
        {hasRolePermissions(ROLE_SETS.MANAGER) && <CreateFormModal />}
      </div>
    </div>
  );
};

export default RepositoryHeader;
